<app-code-view [isTitle]="true">
  <h4 Ctitle>{{'Upload Resource' | localize}}</h4>
  <div output>
    <mat-stepper linear #stepper (selectionChange)="resetStepper($event, stepper)">
      <mat-step label="{{'FileUploadFormWizard.fileType' | localize}}" [stepControl]="fileTypeFormGroup">
        <form class="m-t-24" [formGroup]="fileTypeFormGroup">
          <div class="row">
            @for (file of fileUploadOptionsList(); track file.description) {
              <div class="col-lg-2 col-sm-4 col-6">
                <mat-card
                  class="shadow-none text-center bg-light-{{ file.color }} {{selectedFileType === file.type && 'border border-' + file.color}}">
                  <button (click)="selectFileType(file.type); moveToSecondStep(stepper)"
                          style="border: none; background-color: transparent; cursor: pointer;">
                    <mat-card-content>
                      <span class="d-flex justify-content-center w-100 h-100">
                        <i-tabler name="{{file.icon}}" style="color: white; width: 64px; height: 64px;"></i-tabler>
                      </span>
                      <h4 class="f-s-14 f-w-600 text-{{ file.color }} m-t-8">
                        {{ file.description | localize }}
                      </h4>
                    </mat-card-content>
                  </button>
                </mat-card>
              </div>
            }
          </div>
          <mat-form-field appearance="outline" class="w-100" *ngIf="showSelectionFileTypeInput">
            <input matInput formControlName="fileTypeSelection" required/>
          </mat-form-field>
        </form>
      </mat-step>
      <mat-step label="{{ 'FileUploadFormWizard.resources' | localize }}" [stepControl]="pickFormGroup(selectedFileType)">
        <form class="m-t-24" [formGroup]="pickFormGroup(selectedFileType)">
          <!--          TODO : Dosya adı düzenleme işlemi daha sonra eklenecektir.-->
          <file-upload-area
            [maxFileSize]="maxFileSize"
            *ngIf="selectedFileType === AcceptedFileType.DOCUMENT"
            [fileUploadOptionsList]="fileUploadOptionsList()"
            [formGroup]="fileUploadFormGroup"
            (fileUploadEvent)="setFormGroupFile($event, AcceptedFileType.DOCUMENT)"
            (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], AcceptedFileType.DOCUMENT, $event[2])"
            (fileRemoveEvent)="removeFormGroupFile($event, AcceptedFileType.DOCUMENT)"
            (showUserDecisionSwitchChange)="showUserDecisionsByFileType($event[0], $event[1], $event[2])"
            [selectionType]="'document'"
            [acceptedTypes]="['.pdf', '.docx', '.odt', '.txt', '.md']"
            [loadableFileTypes]="'.pdf, .docx, .odt, .txt, .md.'"
            >
          </file-upload-area>
          <div *ngIf="selectedFileType === AcceptedFileType.SCRAPER">
<!--            TODO : Yetki kontrollerine göre kullanıcıların görüp görmemesi sağlanacaktır.-->
            <mat-label class="f-s-14 f-w-600 d-block m-b-16">
              URL:
            </mat-label>
            <mat-form-field appearance="outline" class="w-100 p-4" >
              <input
                #urlInput
                matInput
                formControlName="url"
                placeholder="https://"
                required
                (blur)="prependHttpsIfMissing()" />
            </mat-form-field>
            <div class="d-flex justify-content-around align-items-start">
<!--              <div class="flex-1-auto p-5">-->
<!--                <mat-form-field appearance="outline" class="w-100">-->
<!--                  <mat-label class="f-s-14 f-w-600 d-block m-b-10">-->
<!--                    Mode:-->
<!--                  </mat-label>-->
<!--                  <mat-select formControlName="mode">-->
<!--                    @for (mode of extractionModes; track mode.toString()) {-->
<!--                      <mat-option [value]="mode">-->
<!--                        {{ mode }}-->
<!--                      </mat-option>-->
<!--                    }-->
<!--                  </mat-select>-->
<!--                </mat-form-field>-->
<!--                <mat-form-field appearance="outline" class="w-100">-->
<!--                  <mat-label class="f-s-14 f-w-600 d-block m-b-16">-->
<!--                    Language:-->
<!--                  </mat-label>-->
<!--                  <mat-select formControlName="language">-->
<!--                    @for (language of languages; track language.toString()) {-->
<!--                      <mat-option [value]="language">-->
<!--                        {{ language }}-->
<!--                      </mat-option>-->
<!--                    }-->
<!--                  </mat-select>-->
<!--                </mat-form-field>-->
<!--              </div>-->
              <div class="flex-1-auto p-5">
                <mat-label class="f-s-14 f-w-600 d-block m-b-16">
                  {{'UserDecisions.scraperOptions' | localize}}
                </mat-label>
                <div>
<!--                  <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">-->
<!--                    <span style="padding-bottom: 16px;">-->
<!--                      Exclude lines-->
<!--                    </span>-->
<!--                    <mat-slide-toggle [checked]="this.urlUploadFormGroup.get('exclude_lines')?.getRawValue()?.value" (change)="changeScraperOptions($event, 'exclude_lines')" ></mat-slide-toggle>-->
<!--                  </div>-->
                  <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
                    <span style="padding-bottom: 16px;">
                      {{'UserDecisions.includeImages' | localize}}
                    </span>
                    <mat-slide-toggle [checked]="this.urlUploadFormGroup.get('include_images')?.getRawValue()?.value" (change)="changeScraperOptions($event, 'include_images')" ></mat-slide-toggle>
                  </div>
<!--                  <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">-->
<!--                    <span style="padding-bottom: 16px;">-->
<!--                      Include Formatting-->
<!--                    </span>-->
<!--                    <mat-slide-toggle [checked]="this.urlUploadFormGroup.get('include_formatting')?.getRawValue()?.value" (change)="changeScraperOptions($event, 'include_formatting')" ></mat-slide-toggle>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
<!--            <div class="d-flex justify-items-between align-items-center">-->
<!--              <div class="flex-1-auto p-5">-->
<!--                <mat-label class="f-s-14 f-w-600 d-block m-b-16">-->
<!--                  Length Low:-->
<!--                </mat-label>-->
<!--                <mat-form-field appearance="outline" class="w-100" >-->
<!--                  <input matInput formControlName="length_low" type="number" min="0"/>-->
<!--                </mat-form-field>-->
<!--                <mat-label class="f-s-14 f-w-600 d-block m-b-16">-->
<!--                  Length High:-->
<!--                </mat-label>-->
<!--                <mat-form-field appearance="outline" class="w-100" >-->
<!--                  <input matInput formControlName="length_high" type="number" min="0"/>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="flex-1-auto p-5">-->
<!--                <mat-label class="f-s-14 f-w-600 d-block m-b-16">-->
<!--                  Stopwords Low:-->
<!--                </mat-label>-->
<!--                <mat-form-field appearance="outline" class="w-100" >-->
<!--                  <input matInput formControlName="stop_words_low" type="number" min="0"/>-->
<!--                </mat-form-field>-->
<!--                <mat-label class="f-s-14 f-w-600 d-block m-b-16">-->
<!--                  Stopwords High:-->
<!--                </mat-label>-->
<!--                <mat-form-field appearance="outline" class="w-100" >-->
<!--                  <input matInput formControlName="stop_words_high" type="number" min="0"/>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <file-upload-area
            [maxFileSize]="maxFileSize"
            *ngIf="selectedFileType === AcceptedFileType.MULTIMEDIA"
            [fileUploadOptionsList]="fileUploadOptionsList()"
            [formGroup]="multimediaUploadFormGroup"
            (fileUploadEvent)="setFormGroupFile($event, AcceptedFileType.MULTIMEDIA)"
            (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], AcceptedFileType.MULTIMEDIA, $event[2])"
            (showUserDecisionSwitchChange)="showUserDecisionsByFileType($event[0], $event[1], $event[2])"
            (fileRemoveEvent)="removeFormGroupFile($event, AcceptedFileType.MULTIMEDIA)"
            [selectionType]="'multimedia'"
            [acceptedTypes]="['.png', '.jpg', '.jpeg', '.mp4', '.avi']"
            [loadableFileTypes]="'.png, .jpg, .jpeg, .mp4, .avi'"
          >
          </file-upload-area>
          <file-upload-area
            [maxFileSize]="maxFileSize"
            *ngIf="selectedFileType === AcceptedFileType.TABLE"
            [fileUploadOptionsList]="fileUploadOptionsList()"
            [formGroup]="excelUploadFormGroup"
            (fileUploadEvent)="setFormGroupFile($event, AcceptedFileType.TABLE)"
            (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], AcceptedFileType.TABLE, $event[2])"
            (showUserDecisionSwitchChange)="showUserDecisionsByFileType($event[0], $event[1], $event[2])"
            (fileRemoveEvent)="removeFormGroupFile($event, AcceptedFileType.TABLE)"
            [selectionType]="'table'"
            [acceptedTypes]="['.xlsx', '.xls', '.ods', '.csv']"
            [loadableFileTypes]="'.xlsx, .xls, .ods, .csv'"
            (updateSheetHeaderKeyChange)="updateSheetHeaderKey($event[0], $event[1], $event[2])"
          >
          </file-upload-area>
          <file-upload-area
             [maxFileSize]="maxFileSize"
             *ngIf="selectedFileType === AcceptedFileType.ORGANIZATION"
             [fileUploadOptionsList]="fileUploadOptionsList()"
             [formGroup]="organizationUploadFormGroup"
             (fileUploadEvent)="setFormGroupFile($event, AcceptedFileType.ORGANIZATION)"
             (userDecisionChangeEvent)="changeUserDecision($event[0], $event[1], AcceptedFileType.ORGANIZATION, $event[2])"
             (showUserDecisionSwitchChange)="showUserDecisionsByFileType($event[0], $event[1], $event[2])"
             (fileRemoveEvent)="removeFormGroupFile($event, AcceptedFileType.ORGANIZATION)"
             [selectionType]="'organization'"
             [acceptedTypes]="['.xlsx', '.xls', '.ods', '.csv']"
             [loadableFileTypes]="'.xlsx, .xls, .ods, .csv'"
             (updateSheetHeaderKeyChange)="updateSheetHeaderKey($event[0], $event[1], $event[2])"
             (columnMappingsChange)="addColumnMappingToOrganizationForm($event[0], $event[1], $event[2], $event[3])"
             (divisionColumnsChange)="updateDivisionColumns($event)"
          >
          </file-upload-area>
          <app-qa-input
             *ngIf="selectedFileType === AcceptedFileType.QA"
             [formGroup]="qaUploadFormGroup"
             (qaDataChange)="onQaDataChange($event)"
          >
          </app-qa-input>
          <div [ngStyle]="{'margin': anyFilesUploaded ? '' : '1rem'}" class="d-flex align-items-center justify-content-between">
            <button mat-flat-button class="bg-error text-white" matStepperPrevious (click)="resetStepper($event, stepper)">
              {{ "FileUploadFormWizard.back" | localize }}
            </button>
            <button mat-flat-button matStepperNext (click)="validateAndProceed(stepper)">{{ "FileUploadFormWizard.next" | localize }}</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ "FileUploadFormWizard.finish" | localize }}</ng-template>
        <h4 class="mat-headline-6 m-t-24">{{ "FileUploadFormWizard.termsAndCondition" | localize }}</h4>
        <p class="m-t-8 f-s-14">
          {{ "FileUploadFormWizard.fileActivation" | localize }} <a href="/apps/resource-management" target="_blank">{{ "FileUploadFormWizard.checkActivation" | localize }}</a>
        </p>
        <div class="d-flex justify-content-between m-t-16">
          <button
            mat-flat-button
            class="bg-error text-white"
            matStepperPrevious
            [disabled]="isFileUploading"
          >
            {{ "FileUploadFormWizard.back" | localize }}
          </button>
          <button mat-flat-button [disabled]="isFileUploading" (click)="sendData(stepper, selectedFileType)">
            <div *ngIf="isFileUploading">
              <mat-spinner style="max-height: 20px; max-width: 20px;" mode="indeterminate" color="white"></mat-spinner>
            </div>
            <span *ngIf="!isFileUploading">{{ "FileUploadFormWizard.finish" | localize }}</span>
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</app-code-view>
